export default "__VITE_ASSET__Bg18HvN3__"